import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, MusicIcon, MicIcon, PartyPopperIcon, GuitarIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
const samples = [{
  title: 'Live-Cover-Sample',
  description: 'Ausschnitt aus einem Live-Auftritt',
  icon: MusicIcon,
  duration: '—:——'
}, {
  title: 'Akustik/reduziertes Arrangement',
  description: 'Unplugged-Version eines Covers',
  icon: GuitarIcon,
  duration: '—:——'
}, {
  title: 'Demo einer eigenen Produktion',
  description: 'Original-Song von Tuesday',
  icon: MicIcon,
  duration: '—:——'
}, {
  title: 'Party/Uptempo-Set',
  description: 'Energiegeladene Live-Atmosphäre',
  icon: PartyPopperIcon,
  duration: '—:——'
}];
export function AudioSamples() {
  return <div className="w-full min-h-screen py-16 px-4 sm:px-6 lg:px-8" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        <motion.div {...fadeInUp} className="text-center mb-12" data-id="element-57">
          <h1 className="font-display text-5xl sm:text-6xl font-bold text-primary mb-6" data-id="element-58">
            Audio-Samples
          </h1>
          <div className="bg-[var(--color-accent-hover)] border border-accent rounded-lg p-6 max-w-2xl mx-auto" data-id="element-59">
            <p className="text-primary text-lg" data-id="element-60">
              Audio-Samples folgen in Kürze — melde dich gerne direkt bei uns.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-61">
          {samples.map((sample, index) => <motion.div key={sample.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-surface border border-border-base rounded-lg p-6" data-id="element-62">
              <div className="flex items-start gap-4 mb-4" data-id="element-63">
                <sample.icon size={32} className="text-accent flex-shrink-0" data-id="element-64" />
                <div className="flex-1" data-id="element-65">
                  <h3 className="font-display text-xl font-semibold text-primary mb-1" data-id="element-66">
                    {sample.title}
                  </h3>
                  <p className="text-muted text-sm" data-id="element-67">{sample.description}</p>
                </div>
              </div>

              <div className="flex items-center gap-4 pt-4 border-t border-border-base" data-id="element-68">
                <button disabled className="w-12 h-12 rounded-full bg-surface flex items-center justify-center cursor-not-allowed opacity-50" aria-label="Play audio sample" data-id="element-69">
                  <PlayIcon size={20} className="text-muted ml-1" data-id="element-70" />
                </button>
                <div className="flex-1" data-id="element-71">
                  <div className="h-2 bg-surface rounded-full mb-1" data-id="element-72"></div>
                  <p className="text-muted text-sm" data-id="element-73">{sample.duration}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div {...fadeInUp} className="mt-12 text-center" data-id="element-74">
          <p className="text-muted mb-4" data-id="element-75">
            Für Audio-Samples und weitere Informationen kontaktiere uns direkt:
          </p>
          <a href="mailto:booking@tuesday-band.de" className="inline-block px-8 py-3 bg-secondary text-[var(--color-secondary-text)] font-medium rounded hover:bg-[var(--color-secondary-solid-hover)] transition-colors" data-id="element-76">
            booking@tuesday-band.de
          </a>
        </motion.div>
      </div>
    </div>;
}